import { useEffect } from "react";
import { Formik } from "formik";
import { useSelector, useDispatch } from "react-redux";

// components
import MainHeader from "../../components/Header/MainHeader";
import DataSafetyMessage from "../../components/Messages/DataSafetyMessage";

// methods
import useResponse from "../../hooks/useResponse";
import ServicesAPI from "../../services/services";
import { addLoanAmount } from "../../redux/slices/registerSlice";
import { enterLoanAmountValidation } from "../../validations/user.validation";
import CustomButton from "../../components/Button/CustomButton";
import { googleEvent_LOJ045, googleEvent_LOJ046 } from "../../lib/google-analytics";
import { googleEvent_LOJ043 } from "../../lib/google-analytics-loan-journey-events";
import { handlehideContextualLoader, handleShowContextualLoader } from "../../utils/contextualLoaderTrigger";

export default function LoanAmount() {
  const { loanAmount } = useSelector((state) => state.register);
  const { repeatCustomer } = useSelector((state) => state.user);

  const dispatch = useDispatch();

  const { incompleteDetailsUpdate } = new ServicesAPI();
  const { handleStep } = useResponse();

  useEffect(() => {
    googleEvent_LOJ043();
  }, []);

  return (
    <div className="wrapper">
      <Formik
        enableReinitialize
        initialValues={{ loanAmount: loanAmount || "" }}
        validationSchema={enterLoanAmountValidation}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true);

          setTimeout(async () => {
            if (repeatCustomer) {
              dispatch(addLoanAmount(values.loanAmount));
              window.location.href = "/confirm-details";
              localStorage.setItem("loanAmount", values.loanAmount);
            } else {
              const res = await incompleteDetailsUpdate(
                { key: "loanRequeried", value: values.loanAmount },
                repeatCustomer
              );
              if (res) {
                dispatch(addLoanAmount(values.loanAmount));
                handleStep();
              }
            }

            //  Events
            googleEvent_LOJ046(values.loanAmount);

            setSubmitting(false);
          }, 500);
        }}
      >
        {({ errors, values, touched, isSubmitting, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
          <form onSubmit={handleSubmit} style={{ height: "100%" }}>
            <div className="vertical-column-layout">
              <div className="vertical-column-top">
                <MainHeader
                  title="Loan Amount"
                  showProgress={true}
                  percent={25}
                  backPageName={repeatCustomer ? "/dashboard" : ""}
                />

                <div className="mb-3">
                  <p className="label">Enter loan amount</p>
                </div>

                <div className="form-group">
                  <input
                    type="tel"
                    className="form-control"
                    placeholder="Enter loan amount"
                    name="loanAmount"
                    value={values.loanAmount}
                    onChange={(e) => {
                      const input = e.target.value;
                      if (/^\d*$/.test(input)) {
                        setFieldValue("loanAmount", e.target.value);
                        googleEvent_LOJ045(input);
                      }
                    }}
                    onBlur={(e) => {
                      setFieldValue("loanAmount", e.target.value.trim());
                    }}
                    autoComplete="off"
                  />

                  {touched.loanAmount && errors.loanAmount ? (
                    <div className="error-msg">{errors.loanAmount}</div>
                  ) : null}
                </div>
              </div>

              <div className="vertical-column-bottom">
                <DataSafetyMessage />

                <CustomButton text="Next" type="submit" />
              </div>
            </div>

            {isSubmitting ? handleShowContextualLoader("Please wait...") : handlehideContextualLoader()}
          </form>
        )}
      </Formik>
    </div>
  );
}
